module.exports = __webpack_public_path__ + "media/icons/bell_light-blue-03d7b3d5.svg";